module.exports = __webpack_public_path__ + "static/img/1-1.be0a782.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/2/1-1.png
// module id = jnnr
// module chunks = 0